// extracted by mini-css-extract-plugin
module.exports = {"data-table":"AppointmentList_data-table__2fS7a","export-button":"AppointmentList_export-button__3yOiN"};